export default __webpack_public_path__ + "static/media/remove.7cbb3265.svg";